import { api } from "@/lib/api";

const SID_KEY = "nox_sid";
const SRC_KEY = "nox_src";

const SEARCH = ["google", "bing", "duckduckgo", "yahoo", "ecosia", "baidu", "yandex"];
const SOCIAL = ["facebook", "instagram", "twitter", "t.co", "x.com", "linkedin", "youtube", "reddit", "tiktok", "pinterest", "fb.com", "lnkd.in"];

function classifySource() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = (params.get("utm_source") || "").toLowerCase();
    const ref = document.referrer || "";
    let host = "";
    try {
      host = ref ? new URL(ref).hostname.toLowerCase() : "";
    } catch {
      host = "";
    }
    const selfHost = (window.location.hostname || "").toLowerCase();
    const probe = (utm || host);
    const has = (arr) => arr.some((k) => probe.includes(k));
    if (utm) {
      if (has(SEARCH)) return "Search";
      if (has(SOCIAL)) return "Social";
      return "Campaign";
    }
    if (!ref || host === selfHost) return "Direct";
    if (has(SEARCH)) return "Search";
    if (has(SOCIAL)) return "Social";
    return "Referral";
  } catch {
    return "Direct";
  }
}

export function getSession() {
  try {
    let sid = localStorage.getItem(SID_KEY);
    if (!sid) {
      sid =
        (typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      localStorage.setItem(SID_KEY, sid);
    }
    let src = localStorage.getItem(SRC_KEY);
    if (!src) {
      src = classifySource(); // first-touch attribution for this visitor
      localStorage.setItem(SRC_KEY, src);
    }
    return { sid, src };
  } catch {
    return { sid: "", src: "Direct" };
  }
}

export function trackPage(path) {
  const { sid, src } = getSession();
  api.post("/track", { path, sid, src }).catch(() => {});
}
